import React from "react";
import FormControl from "./components/base_ui/inputs/form_control";
import Checkbox, { CheckboxOverrides } from "./components/base_ui/inputs/checkbox";
import { StyledLink } from "baseui/link";
import { LEGAL_POLICY_LINKS } from "../utils/legal_policy_links";
import styled from "styled-components";

const TermsSpan = styled.span`
  display: inline-block;
`;

const LegalTermsCheckboxOverrides: CheckboxOverrides = {
  Label: {
    style: ({ $theme }) => ({
      fontFamily: $theme.typography.LabelMedium.fontFamily,
      fontWeight: $theme.typography.LabelMedium.fontWeight,
      fontSize: $theme.typography.LabelMedium.fontSize,
      lineHeight: $theme.typography.LabelMedium.lineHeight,
      textTransform: "none",
    }),
  },
};

export default function LegalTermsAgreement({
  acceptedLegalTerms,
  hasError,
  onAgreementStatusChanged,
}: {
  acceptedLegalTerms: boolean;
  hasError?: boolean;
  onAgreementStatusChanged: (agreementStatus: boolean) => void;
}) {
  const renderIAgreeCheckbox = () => {
    return (
      <TermsSpan>
        <FormControl
          error={hasError}
          caption={
            hasError ? 'Please agree to the "Privacy Policy" and "Terms of Use" to proceed.' : ""
          }
        >
          <Checkbox
            aria-label="agreed to legal terms"
            name="agreed_to_legal_terms"
            checked={acceptedLegalTerms}
            onChange={(event) => onAgreementStatusChanged(event.currentTarget.checked)}
            overrides={LegalTermsCheckboxOverrides}
            dataTest={"checkbox-agree-to-legal-terms"}
          >
            I have read and agree to the{" "}
            <StyledLink
              href={LEGAL_POLICY_LINKS.PRIVACY_POLICY_URL_PDF}
              target="_blank"
              aria-label="Privacy Policy, opens a PDF"
            >
              Privacy Policy
            </StyledLink>{" "}
            and to the{" "}
            <StyledLink
              href={LEGAL_POLICY_LINKS.TERMS_OF_USE_URL_PDF}
              target="_blank"
              aria-label="Terms of Use, opens a PDF"
            >
              Terms of Use
            </StyledLink>
          </Checkbox>
        </FormControl>
      </TermsSpan>
    );
  };

  return <div>{renderIAgreeCheckbox()}</div>;
}
